import { z } from 'my-zod'
import { predefinedQuestionKeyOptions } from './pre-defined-questions'

export const additionalWaiverQuestionTypeOptions = [
  'checkboxOptional',
  'checkboxRequired',
  'textOptional',
  'textRequired',
  'dropdownOptional',
  'dropdownRequired',
  'multiselectOptional',
  'multiselectRequired'
] as const

export const AdditionalWaiverQuestionType = z.enum(additionalWaiverQuestionTypeOptions)
export type AdditionalWaiverQuestionType = z.infer<typeof AdditionalWaiverQuestionType>

export const additionalWaiverQuestionTypeLabels: { [key in AdditionalWaiverQuestionType]: string } = {
  checkboxOptional: 'Checkbox (Optional)',
  checkboxRequired: 'Checkbox (Required)',
  textOptional: 'Text (Optional)',
  textRequired: 'Text (Required)',
  dropdownOptional: 'Dropdown (Optional)',
  dropdownRequired: 'Dropdown (Required)',
  multiselectOptional: 'Multiselect (Optional)',
  multiselectRequired: 'Multiselect (Required)'
}

export const additionalWaiverQuestionMetadata = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('checkboxOptional')
  }),
  z.object({
    type: z.literal('checkboxRequired')
  }),
  z.object({
    type: z.literal('textOptional')
  }),
  z.object({
    type: z.literal('textRequired')
  }),
  z.object({
    type: z.literal('dropdownOptional'),
    options: z
      .array(z.string().trim().min(1, 'Option cannot be empty'))
      .min(2, 'At least two options are required')
      .max(20, 'No more than 20 options are allowed')
  }),
  z.object({
    type: z.literal('dropdownRequired'),
    options: z
      .array(z.string().trim().min(1, 'Option cannot be empty'))
      .min(2, 'At least two options are required')
      .max(20, 'No more than 20 options are allowed')
  }),
  z.object({
    type: z.literal('multiselectOptional'),
    options: z
      .array(z.string().trim().min(1, 'Option cannot be empty'))
      .min(2, 'At least two options are required')
      .max(20, 'No more than 20 options are allowed')
  }),
  z.object({
    type: z.literal('multiselectRequired'),
    options: z
      .array(z.string().trim().min(1, 'Option cannot be empty'))
      .min(2, 'At least two options are required')
      .max(20, 'No more than 20 options are allowed')
  })
])

// Main question model with description on base and metadata field for type-specific data
export const additionalWaiverQuestion = z.object({
  id: z.string(),
  prompt: z.string().min(1).max(256),
  description: z.string().max(256).nullish(),
  orderOfAppearance: z.number().int().nonnegative(),
  metadata: additionalWaiverQuestionMetadata,
  predefinedQuestionKey: z.enum(predefinedQuestionKeyOptions).nullable()
})

export type AdditionalWaiverQuestion = z.infer<typeof additionalWaiverQuestion>
